module.exports = __webpack_public_path__ + "img/vignettes-asso_0011_clubhouse.7ba1e188.jpg";